import { LOGIN_ROUTE } from "@/utils/const";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const { isAuth } = useAuth();

  if (!isAuth) {
    return <Navigate to={LOGIN_ROUTE} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
